import { ICountryRates } from './rateSummary.models';
import { useRateSummaryTable } from './rateSummaryTable.hook';
import * as S from './rateSummaryTable.style';

export const RateSummaryTable: React.FC<{ aemData: ICountryRates }> = ({ aemData }) => {
  const { data, isDataEmpty, isDesktop } = useRateSummaryTable(aemData);

  if (isDataEmpty) return null;

  if (isDesktop)
    return (
      <S.TableContainerInDesktop>
        <S.TableHeaderDesktop>
          <S.TopLeftCorner>Paese</S.TopLeftCorner>
          {data[0].rates.map((obj) => (
            <S.CellDesktop key={obj.title}>{obj.title}</S.CellDesktop>
          ))}
        </S.TableHeaderDesktop>
        <S.TableBodyDesktop>
          {data.map((obj) => (
            <S.TableBodyRow key={obj.title}>
              <S.CellDesktop>{obj.title}</S.CellDesktop>
              {obj.rates.map((r) => (
                <S.CellDesktop key={r.value}>{r.value}</S.CellDesktop>
              ))}
            </S.TableBodyRow>
          ))}
        </S.TableBodyDesktop>
      </S.TableContainerInDesktop>
    );

  return (
    <S.RateSummaryTableNoDesktop>
      {data.map((obj) => (
        <S.CountrySectionInNoDesktop key={obj.title}>
          <S.CountryTitleNoDesktop>{obj.title}</S.CountryTitleNoDesktop>
          {obj.rates.map((o) => (
            <S.DataNoDesktopRow key={o.title}>
              <S.DataTypeNoDesktop>{o.title}</S.DataTypeNoDesktop>
              <S.DataValueNoDesktop>{o.value}</S.DataValueNoDesktop>
            </S.DataNoDesktopRow>
          ))}
        </S.CountrySectionInNoDesktop>
      ))}
    </S.RateSummaryTableNoDesktop>
  );
};

export default RateSummaryTable;
